import { pgEnum } from 'drizzle-orm/pg-core'

export const userStatusEnum = pgEnum('user_status', ['active', 'suspended'])

export const categoryStatusEnum = pgEnum('category_status', [
    'active',
    'inactive',
])

export const targetingScopeEnum = pgEnum('targeting_scope', [
    'platform_wide',
    'client_specific',
])

export const benefitStatusEnum = pgEnum('benefit_status', [
    'draft',
    'published',
    'expired',
    'rejected',
])

export const accessTypeEnum = pgEnum('access_type', ['allowed', 'blocked'])

export const raffleStatusEnum = pgEnum('raffle_status', [
    'open',
    'closed',
    'drawn',
    'completed',
    'cancelled',
])
